document.addEventListener('DOMContentLoaded', () => {
  const swatchItems = document.querySelectorAll('.ColorSwatchList .HorizontalList__Item');
  if (!swatchItems.length) return;

  swatchItems.forEach((item) => {
    item.addEventListener('mouseenter', () => {
      document.querySelectorAll('.ColorSwatch-image.active').forEach((swatch) => {
        swatch.classList.remove('active');
      });

      const currentSwatch = item.querySelector('.ColorSwatch-image');
      if (!currentSwatch) return;

      currentSwatch.classList.add('active');
      const selectedValue = document.querySelector('.ProductForm__SelectedValue');
      if (selectedValue) selectedValue.textContent = currentSwatch.getAttribute('colorname') || '';
    });
  });
});
